import React from 'react';
import { connect } from 'react-redux';

import { ordersFindSetFilterType } from './../store/ordersFind/actions';
import { getOrdersFind, getOrdersTypesWithCount } from './../store/ordersFind/selectors';

import Checkbox from './Checkbox';

const TypesSearchForm = props => {
    const { filter, orderTypes, setFilterType } = props;
    return (
        <ul className="menu">
            {orderTypes.map(item =>
                <li key={item.name} className="menu-item">
                    <Checkbox name={item.name} disabled={!item.count} onChange={setFilterType} checked={filter.type.indexOf(item.name) > -1}>
                        {item.name}
                        {!!item.count &&
                            <span> ({item.count})</span>
                        }
                    </Checkbox>
                </li>
            )}
        </ul>
    );
};

const mapStateToProps = (state, ownProps) => {
    const filter = state.ordersFind.filter[ownProps.typeId];
    const orderTypes = getOrdersTypesWithCount[ownProps.typeId](state, ownProps);
    const orders = getOrdersFind[ownProps.typeId](state);
    return { filter, orderTypes, orders };
};

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        setFilterType: event => dispatch(ordersFindSetFilterType(ownProps.typeId, event.target.checked, event.target.name)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(TypesSearchForm);


// WEBPACK FOOTER //
// ./src/components/TypesSearchForm.js